// Copyright (c) 2017 Deere & Company

import {
    Component,
    PropTypes
} from 'react';
import {environmentIsProd, environmentIsReady} from '../shared/services/environment';
import {
    provideWalkMeLanguage,
    updateWalkMeLanguage
} from '../shared/services/walkme';

class WalkMe extends Component {

    componentWillMount = () => {

        this.setState({
            initComplete: false
        });

    };

    componentDidUpdate() {

        if (!this.state.initComplete && environmentIsReady(this.props.appConfig) && this.props.isSapUp) {

            /* eslint-disable camelcase, no-underscore-dangle */

            window.walkme_user_identifier = this.props.user.id;
            window._walkmeConfig = {smartLoad: true};

            /* eslint-enable camelcase, no-underscore-dangle */

            const isProd = environmentIsProd(this.props.appConfig);

            const script = document.createElement('script');

            script.src = isProd ? 'https://cdn.walkme.com/users/f04d04c9f4c54559a5197961b6cf95a5/walkme_f04d04c9f4c54559a5197961b6cf95a5_https.js' : 'https://cdn.walkme.com/users/f04d04c9f4c54559a5197961b6cf95a5/test/walkme_f04d04c9f4c54559a5197961b6cf95a5_https.js';
            script.async = true;

            document.body.appendChild(script);

            this.markComplete();

        }

        const language = this.props.user.getLocale();

        updateWalkMeLanguage(language);
        provideWalkMeLanguage(language);

    }

    markComplete = () => {

        this.setState({
            initComplete: true
        });

    };

    render = () => null;

}

WalkMe.displayName = 'WalkMe';
WalkMe.propTypes = {
    appConfig: PropTypes.object.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired
};

export default WalkMe;



// WEBPACK FOOTER //
// ./src/app/walkme.js